<template>
    <div class="relative">
        <Loading class="h-full" :class="getApplicationType() === 'backend' ? 'flex flex-row' : ''" :loading="loading" :text="$t('loading') + '...'">
            <Impersonate v-if="!loading" />

            <WebNotification v-if="!loading" />

            <div :class="[$store.getters['settings/getBackendSidebarStateByName']('backend_sidebar') ? 'xl:min-w-[15%]' : 'xl:w-[100px]', 'z-40']">
                <Sidebar v-if="getApplicationType() === 'backend'" class="sticky top-0" />
            </div>

            <div :class="mainViewClass">
                <Header v-if="!loading && !$route.meta.hideHeader">
                    <!-- Discount -->
                    <DiscountBanner />
                    <!-- Discount End -->

                    <!-- SonderBerichte -->
                    <SonderBerichteNotification />
                    <!-- SonderBerichte End -->

                    <Notification v-if="showReloadPage" class="bg-red text-white border-b border-gray-300 cursor-pointer" @click="reloadPage">
                        <p>
                            {{ $t('new_version_available') }}
                            <span class="underline">{{ $t('plain_here') }}</span>
                            {{ $t('reload_website') }}
                        </p>
                    </Notification>
                    <Notification
                        v-show="!loading && $store.getters['user/isLoggedIn'] && !$store.getters['user/isEmailVerified']"
                        class="bg-red text-white border-b border-gray-300"
                    >
                        <p>
                            {{ $t('not_confirmed_mail') }}
                            <router-link to="/email/verify" class="cursor-pointer underline">{{ $t('resend_email') }}</router-link
                            >.
                        </p>
                    </Notification>
                    <Notification v-if="$meta.message" class="bg-red text-white border-b border-gray-300">
                        <p>
                            {{ $translate($meta.message) }}
                        </p>
                    </Notification>
                </Header>
                <div class="w-full transition-all duration-150 ease-in-out relative">
                    <div ref="header_gap" style="height: var(--headerHeight)"></div>
                    <div class="flex flex-col">
                        <router-view></router-view>
                        <Footer v-if="getApplicationType() === 'frontend' && !$route.meta.hideFooter" />
                    </div>
                </div>
                <BackToTop v-if="showBackToTop" class="absolute bottom-[15px] right-[25px] z-10" />
            </div>
        </Loading>
        <HKCMLiveChatWidget />
        <!-- <RegionSelectPopup v-if="!loading"/> -->
    </div>
</template>

<script>
import api from './api';
import { mapGetters } from 'vuex';
import { loadContent } from './loadContent';
import Impersonate from './components/Impersonate.vue';
import WebNotification from './components/WebNotification.vue';
import AOS from 'aos';
import 'aos/dist/aos.css';
import SonderBerichteNotification from './components/SonderBerichteNotification.vue';
import DiscountBanner from './components/DiscountBanner.vue';
import HKCMLiveChatWidget from './components/miscellaneous/HKCMLiveChatWidget.vue';
import _ from 'lodash';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import i18next from 'i18next';
import { getQueryParameterByName } from './helpers';
import { routes } from './routes.js';

export default {
    components: {
        SonderBerichteNotification,
        DiscountBanner
    },
    data: () => ({
        data: null,
        loading: true,
        showBackToTop: false,
        promisses: [],
        sidebarExpanded: true,
        showReloadPage: false
    }),
    mounted() {
        this.$echo.channel('global').listen('BundleUpdated', (e) => {
            this.showReloadPage = true;
        });

        AOS.init({
            offset: 40,
            once: true
        });

        // Load User
        if (window.meta.authenticated) {
            this.promisses.push(this.$store.dispatch('user/user', { componentId: this.$.uid }), this.$store.dispatch('cart/index'));
        } else {
            if (window.meta.cart) {
                this.promisses.push(this.$store.dispatch('cart/index'));
            }
        }

        // Check if User is newly logged in and subscribe to Events
        this.$watch(
            (vm) => [vm.isLoggedIn],
            (val) => {
                if (this.isLoggedIn) {
                    // Private Event
                    loadContent();

                    if (!this.$subscribedToChannel(`App.Models.User.${this.user.id}`)) {
                        this.$echo.private(`App.Models.User.${this.user.id}`).notification((notification) => {
                            if (notification.type === 'broadcast.message') {
                                this.$toast.success(notification.body, {
                                    timeout: 5000,
                                    closeOnClick: true,
                                    toastClassName: 'cursor-pointer',
                                    onClick: () => {
                                        window.location.href = notification.url;
                                    }
                                });
                            }
                        });
                    }
                }
            },
            { immediate: true, deep: true }
        );

        // Load ProductCategories, ProductGroups and Products
        this.$store.dispatch('product_categories/all').then(async (response) => {
            response.data.forEach((productCategory) => {
                this.$store.commit('product_groups/setByProductCategoryId', {
                    product_category_id: productCategory.id,
                    data: productCategory.productGroups
                });
            });

            this.$store.commit('settings/allLoaded', true);
        });

        // Keep the Session valid while the User is still on the Page
        setInterval(
            () => {
                api.post('/ping');
            },
            1000 * 60 * 2
        );
        // ⌃ Time Interval

        // Get the Scroll Position to show the Scroll Top Button
        window.addEventListener('scroll', () => {
            document.pageYOffset > 500 ? (this.showBackToTop = true) : (this.showBackToTop = false);
        });

        // if all promisses are resolved disable loading
        Promise.all(this.promisses).then((values) => {
            this.loading = false;

            _.forEach(window.meta?.message, (message, type) => {
                this.$toast[type === 'danger' ? 'error' : type](message);
            });

            // if(! this.$cookies.get('marketing_toprow_30_05_22')) {
            this.$cookies.set('marketing_toprow_02_10_22', true);
            this.showMarketingBanner = true;
            // }
        });
    },
    unmounted() {
        window.removeEventListener('scroll');
    },
    methods: {
        routes() {
            return routes;
        },
        reloadPage() {
            location.reload();
        }
    },
    computed: {
        ...mapGetters('user', {
            isLoggedIn: 'isLoggedIn',
            user: 'get'
        }),
        ...mapGetters('settings', {
            getApplicationType: 'getApplicationType'
        }),
        mainViewClass() {
            if (this.getApplicationType() === 'backend' && this.$store.getters['settings/getBackendSidebarStateByName']('backend_sidebar')) {
                return 'w-full xl:w-[85%]';
            } else if (this.getApplicationType() === 'backend' && !this.$store.getters['settings/getBackendSidebarStateByName']('backend_sidebar')) {
                return 'w-full';
            } else {
                return 'w-full';
            }
        },
        currentRouteName() {
            return this.$route.name;
        }
    },
    watch: {
        $route(to, from) {
            if (to.path === '/dashboard' && to.query.neukunde) {
                this.$router.push({ query: {} });
                const driverObj = driver({
                    showProgress: true,
                    nextBtnText: i18next.t('plain_next'),
                    prevBtnText: i18next.t('plain_back'),
                    doneBtnText: i18next.t('plain_finish'),
                    steps: [
                        {
                            element: '#Start',
                            popover: {
                                title: i18next.t('guide_welcome'),
                                description: i18next.t('guide_welcome_description'),
                                side: 'left',
                                align: 'start'
                            }
                        },
                        {
                            element: '.tourStep-1',
                            popover: {
                                title: i18next.t('guide_analyses'),
                                description: i18next.t('guide_analyses_description'),
                                side: 'left',
                                align: 'start'
                            }
                        },
                        {
                            element: '.tourStep-2',
                            popover: {
                                title: i18next.t('guide_price_targets'),
                                description: i18next.t('guide_price_targets_description'),
                                side: 'left',
                                align: 'start'
                            }
                        },
                        {
                            element: '.tourStep-3',
                            popover: {
                                title: i18next.t('guide_hkcm_portfolio'),
                                description: i18next.t('guide_hkcm_portfolio_description'),
                                side: 'left',
                                align: 'start'
                            }
                        },
                        // {element: '.tourStep-4',
                        //     popover: {
                        //         title: i18next.t('guide_ individual_dashboard'),
                        //         description: i18next.t('guide_ individual_dashboard_description'),
                        //         side: "bottom",
                        //         align: 'start'
                        //     }
                        // },
                        {
                            element: '.tourStep-6',
                            popover: {
                                title: i18next.t('guide_your_profile'),
                                description: i18next.t('guide_your_profile_description'),
                                side: 'bottom',
                                align: 'start',
                                onNextClick: () => {
                                    driverObj.moveNext();
                                    this.$router.push('/dashboard/markets');
                                }
                            }
                        },
                        {
                            element: 'Platzhalter',
                            popover: {
                                title: i18next.t('guide_analyses_overview'),
                                description: i18next.t('guide_analyses_overview_description'),
                                onNextClick: () => {
                                    driverObj.moveNext();
                                    document.querySelector('.driver-popover').style.maxWidth = '100%';
                                }
                            }
                        }
                        // {element: '.tourStep-8',
                        //     popover: {
                        //         title: 'Mehr Infos',
                        //         description: '<p>Für weitere Informationen werfen Sie einen Blick in unser Video zum neuen Dashboard.</p><br/><iframe width="560" height="315" src="https://www.youtube.com/embed/QQnbFibWbuk?si=mahYipqZEkpylxpQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>',
                        //         side: "bottom",
                        //         align: 'start'
                        //     }
                        // },
                    ]
                });
                driverObj.drive();
            }
        }
    }
};
</script>
